import React from 'react';
import { FormField } from '@/components/custom/erp';
import { taxSearchColumns } from '../../cols-definition';
import { Label } from '@/components/ui/label';
const CoQuanThueForm = ({ mode }: { mode: 'add' | 'edit' | 'view' | 'search' }) => {
  const isDisabled = mode === 'view';
  return (
    <div>
      <div className='max-h-[calc(100vh-150px)] overflow-y-auto'>
        <div className='p-4 md:p-6'>
          <div className='flex flex-col gap-y-4 md:gap-y-6'>
            <div className='space-y-4 md:space-y-6'>
              <div className='flex flex-col sm:flex-row sm:items-center'>
                <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Mã cơ quan thuế</Label>
                <FormField type='text' name='ma_cqt' disabled={isDisabled} />
              </div>

              <div className='flex flex-col sm:flex-row sm:items-center'>
                <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Tên cơ quan thuế</Label>
                <FormField type='text' name='ten_cqt' disabled={isDisabled} />
              </div>

              <div className='flex flex-col sm:flex-row sm:items-center'>
                <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Cơ quan thuế cấp cục</Label>
                <FormField
                  type='text'
                  name='ma_cqt0'
                  disabled={isDisabled}
                  searchEndpoint='/tax-authorities'
                  actionButtons={['add', 'edit']}
                  searchColumns={taxSearchColumns}
                  searchResultValueKey='uuid'
                  headerFields={<CoQuanThueForm mode='search' />}
                />
              </div>

              <div className='flex flex-col sm:flex-row sm:items-center'>
                <Label htmlFor='trang_thai' className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>
                  Trạng thái
                </Label>
                <FormField
                  id='trang_thai'
                  type='select'
                  name='trang_thai'
                  defaultValue={1}
                  disabled={isDisabled}
                  options={[
                    { label: '1. Còn sử dụng', value: 1 },
                    { label: '2. Không sử dụng', value: 2 }
                  ]}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoQuanThueForm;
